import React from "react";
import { Container, Typography, Paper, Card, Box } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import Technologies from "../components/technologies";
import SplitDescription from "../components/splitdescription";

const whatWeOfferItems = [
  {
    src: "/assets/AdvancedAI/textanalysisgif.gif",
    alt: "text analysis",
    text: "Text Analytics",
    width: "65%",
    paddingTop: "0%",
  },
  {
    src: "/assets/AdvancedAI/imagevideogif.gif",
    alt: "image video analysis",
    text: "Image / Video <br/> Analytics",
    width: "65%",
    paddingTop: "0%",
  },
  {
    src: "/assets/AdvancedAI/predictivegif.gif",
    alt: "predictive analysis",
    text: "Predictive <br/> Analytics",
    width: "50%",
    paddingTop: "10%",
  },
  {
    src: "/assets/AdvancedAI/enginesgif.gif",
    alt: "recommendation engines",
    text: "Recommendation <br/> Engines",
    width: "50%",
    paddingTop: "8%",
  },
];

const AdvancedAI = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", overflowX: "hidden" }}>
      <Paper
        elevation={0}
        sx={{
          backgroundImage: 'url("/assets/AdvancedAI/AdvancedAIBG.webp")',
          backgroundPosition: "center",
          backgroundSize: "cover",
          maxWidth: "100%",
          height: "480px",
          display: "flex",
          overflowX: "hidden",
        }}
      >
        <Container
          disableGutters
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            maxWidth: "lg",
            margin: "0 0 0 10%",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: "800",
              fontSize: { xs: "18px", sm: "24px", md: "28px" }, // Font size for different screen sizes
              color: "#FFFFFF",
              lineHeight: "120%",
              letterSpacing: "2%",
              display: "flex",
              justifyContent: "flex-start",
              paddingBottom: "2%",
            }}
          >
            Change what’s possible for your business.
          </Typography>

          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: "800",
              fontSize: { xs: "36px", sm: "48px", md: "60px" }, // Font size for different screen sizes
              color: "#F005A2",
              lineHeight: "120%",
              letterSpacing: "2%",
              display: "flex",
              paddingBottom: "2%",
            }}
          >
            Artificial Intelligence Solutions
          </Typography>

          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: "800",
              fontSize: { xs: "18px", sm: "20px", md: "24px" }, // Font size for different screen sizes
              color: "#FFFFFF",
              lineHeight: "120%",
              letterSpacing: "2%",
              display: "flex",
              justifyContent: "flex-start",
              paddingBottom: "5%",
              padding: { xs: "10px", sm: "15px", md: "20px" },
              marginBottom: { xs: "20px" }, // Padding for different screen sizes
            }}
          >
            Unlock your competitive edge with our custom Artificial Intelligence
            Solutions and AI Consulting.
          </Typography>

          <Link
            to="/clientForm"
            style={{
              display: "flex",
              width: "150.84px",
              height: "52.23px",
              backgroundColor: "#F005A2",
              borderRadius: "45.25px",
              opacity: "100%",
              alignItems: "center",
              justifyContent: "center",
              padding: "0 2% 0 2%",
              textDecoration: "none",
              color: "inherit",
            }}
          >
            <div
              style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontSize: "18px",
                letterSpacing: "8%",
                fontWeight: "700",
              }}
            >
              Talk to Us
            </div>
            <div
              className="submitBtn__Arrow"
              style={{
                width: "32.84px",
                height: "32.23px",
                backgroundColor: "#FFFFFF",
                borderRadius: "45.25px",
                opacity: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "7%",
              }}
            >
              <ArrowForwardIcon></ArrowForwardIcon>
            </div>
          </Link>
        </Container>
      </Paper>

      <SplitDescription heading1={"Our goal is to make AI accessible to all businesses."}
        heading2={'Insights at your doorstep'}
        content1={"Tecloq is one of the leading artificial intelligence solution service providers and data analytics companies in USA providing world-class solutions and product engineering services to start-ups and Fortune 100 companies, with a focus on ISV’s, media publications, and retail service providers. Modernization and a data-first philosophy fuel our efforts to deliver cutting-edge products and solutions."}
        content2={"Enjoy visible operational functionality, 360-degree decision making, and performance analysis as we supply cost-effective services for natural language processing, text-to-speech, machine learning, knowledge virtualization, and more. If top machine learning companies in USA are what you’re looking for, then Tecloq is the right stop for you. Our AI and Machine Learning services blend business, development, and operations data to give actionable insights and give our clients a unified view of their changing business environments, allowing them to take advantage of the automation and resulting in better business outcomes over time."}
        img1={"/assets/AdvancedAI/ourgoals.png"}
        img2={"/assets/AdvancedAI/insights.png"}
      />

      <Box
        sx={{
          maxWidth: "100% !important",
          height: "auto",
          marginTop: { xs: "14%", md: "8%" }, // Smaller top margin on mobile
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "28px", md: "40px" }, // Adjust font size for mobile and desktop
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: "1%",
          }}
        >
          What We Offer
        </Typography>

        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: "lighter",
            fontSize: { xs: "16px", md: "20px" }, // Adjust font size for mobile and desktop
            color: "#000000",
            display: "flex",
            justifyContent: "center",
            paddingBottom: "2%",
          }}
        >
          AI and Machine Learning Development Services
        </Typography>
      </Box>

      {/* What we offer boxex */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "repeat(2, 1fr)", md: "repeat(4, 1fr)" },
          gap: "20px",
          justifyContent: "center",
          padding: "0 5%",
        }}
      >
        {whatWeOfferItems.map((item, index) => (
          <Paper
            key={index}
            elevation={3}
            sx={{
              borderRadius: "5%",
              textAlign: "center",
              padding: "3%",
            }}
          >
            <img
              src={item.src}
              alt={item.alt}
              style={{
                boxSizing: "border-box",
                width: item.width,
                height: "auto",
                paddingTop: item.paddingTop,
              }}
            />
            <Typography
              sx={{
                fontFamily: "Inter",
                fontWeight: "700",
                fontSize: { xs: "14px", md: "16px" },
                lineHeight: "21px",
                textAlign: "center",
                color: "#000000",
                paddingTop: "5%",
              }}
              dangerouslySetInnerHTML={{ __html: item.text }}
            />
          </Paper>
        ))}
      </Box>

      <Paper
        sx={{
          background:
            "linear-gradient(90.92deg, #000000 0.5%, rgba(102, 102, 102, 0) 36.86%)",
          filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))",
          position: "relative",
          maxWidth: "100%",
          height: { xs: "300px", sm: "480px" },
          backgroundColor: "#7F0055",
          marginTop: { xs: "2%", sm: "3%" },
          display: "flex",
          justifyContent: "flex-start",
        }}
      >
        {/* Background Image */}
        <img
          src="/assets/AdvancedAI/transformBusiness.webp"
          alt="Transform"
          loading="lazy"
          style={{
            position: "absolute",
            top: "0",
            height: "100%",
            width: "auto",
            zIndex: "-1",
            filter: { xs: "brightness(40%)", sm: "none" }, // Dull the image on mobile
          }}
        />
        {/* Overlay for mobile background dullness */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.6)", // Dark overlay to dull the image
            zIndex: "-1",
            display: { xs: "block", sm: "none" }, // Display overlay only on mobile
          }}
        />
        <Box
          sx={{
            position: "absolute",
            left: { xs: "10%", sm: "24%" },
            top: { xs: "25%", sm: "30%" },
            display: "flex",
            flexDirection: "column",
            alignItems: "end",
            padding: { xs: "0 10%", sm: "0 5% 0 20%" },
          }}
        >
          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: { xs: "18px", sm: "30px" },
              lineHeight: "120%",
              textAlign: "right",
              letterSpacing: "0.02rem",
              color: "#FFFFFF",
              zIndex: "0",
              paddingBottom: "5%",
            }}
          >
            Transform your business and gain a competitive advantage through
            real-time monitoring, enhanced product delivery, and data-driven
            intelligence with Tecloq.
          </Typography>
          <Link
            to="/clientForm"
            style={{
              display: "flex",
              width: "150.84px",
              height: "52.23px",
              backgroundColor: "#F005A2",
              borderRadius: "45.25px",
              opacity: "100%",
              alignItems: "center",
              justifyContent: "center",
              padding: "0 2% 0 2%",
              textDecoration: "none",
              color: "inherit",
            }}
          >
            <div
              style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontSize: "18px",
                letterSpacing: "8%",
                fontWeight: "700",
              }}
            >
              Know More
            </div>
            <div
              className="submitBtn__Arrow"
              style={{
                width: "32.84px",
                height: "32.23px",
                backgroundColor: "#FFFFFF",
                borderRadius: "45.25px",
                opacity: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "7%",
              }}
            >
              <ArrowForwardIcon />
            </div>
          </Link>
        </Box>
      </Paper>

      {/* Why Tecloq */}

      <Box
        sx={{
          maxWidth: "100%",
          height: "auto",
          marginTop: { xs: "5%", sm: "6%" },
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "28px", sm: "40px" }, // Adjust font size for mobile
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: { xs: "0.5%", sm: "1%" }, // Adjust padding for mobile
            paddingTop: { xs: "5%", sm: "3%" }, // Adjust padding for mobile
          }}
        >
          Why Tecloq?
        </Typography>
        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: "lighter",
            fontSize: { xs: "14px", sm: "20px" }, // Adjust font size for mobile
            color: "#000000",
            display: "flex",
            justifyContent: "center",
            margin: { xs: "5% 5%", sm: "1% 15% 2% 15%" }, // Adjust margins for mobile
            textAlign: "center",
          }}
        >
          Choosing Tecloq as your Data Analytics Services partner means
          embracing a holistic approach to data-driven decision-making. We stand
          out for several reasons.
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          "& > :not(style)": {
            m: 1,
            width: 370,
            height: 700,
          },
          gap: "3%",
        }}
      >
        <Paper
          elevation={3}
          sx={{
            borderRadius: "3%",
            textAlign: "center",
            border: "0.5px solid #FFC3EA",
            alignContent: "center",
            boxShadow: "0px -3px 17px rgba(240, 5, 162, 0.52)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <img
            src="/assets/AdvancedAI/why1.png"
            alt="why1"
            style={{
              width: "70%",
              height: "35%",
              padding: "15% 0px 10% 15%",
            }}
          ></img>
          <Typography
            sx={{
              fontFamily: "Orbitron",
              lineHeight: "120%",
              fontSize: "28px",
              fontStyle: "normal",
              fontWeight: "700",
              color: "#F005A2",
              letterSpacing: "2%",
            }}
          >
            Proven <br /> expertise
          </Typography>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontStyle: "normal",
              lineHeight: "auto",
              padding: "10% 10% 3% 10%",
            }}
          >
            Our AI and automation solutions development experience spans
            virtually all different industries. Being at the forefront of
            software development, we can find the best solution for every kind
            of requirement.
          </Typography>
        </Paper>
        <Paper
          elevation={3}
          sx={{
            borderRadius: "3%",
            textAlign: "center",
            border: "0.5px solid #FFC3EA",
            alignContent: "center",
            boxShadow: "0px -3px 17px rgba(240, 5, 162, 0.52)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <img
            src="/assets/AdvancedAI/why2.png"
            alt="why1"
            style={{
              width: "70%",
              height: "35%",
              padding: "15% 0px 10% 15%",
            }}
          ></img>
          <Typography
            sx={{
              fontFamily: "Orbitron",
              lineHeight: "120%",
              fontSize: "28px",
              fontStyle: "normal",
              fontWeight: "700",
              color: "#F005A2",
              letterSpacing: "2%",
            }}
          >
            Results-driven
            <br />
            methods
          </Typography>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontStyle: "normal",
              lineHeight: "auto",
              padding: "10% 10% 3% 10%",
            }}
          >
            We have always stayed laser-focused on helping clients achieve
            business goals with the right strategy. Our results-driven approach
            has helped hundreds of clients achieve new milestones making us one
            of the top data analytics companies in USA.
          </Typography>
        </Paper>
        <Paper
          elevation={3}
          sx={{
            borderRadius: "3%",
            textAlign: "center",
            border: "0.5px solid #FFC3EA",
            alignContent: "center",
            boxShadow: "0px -3px 17px rgba(240, 5, 162, 0.52)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <img
            src="/assets/AdvancedAI/why3.png"
            alt="why1"
            style={{
              width: "70%",
              height: "35%",
              padding: "15% 0px 10% 15%",
            }}
          ></img>
          <Typography
            sx={{
              fontFamily: "Orbitron",
              lineHeight: "120%",
              fontSize: "28px",
              fontStyle: "normal",
              fontWeight: "700",
              color: "#F005A2",
              letterSpacing: "2%",
            }}
          >
            Real-Time Project
            <br />
            Assistance
          </Typography>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontStyle: "normal",
              lineHeight: "auto",
              padding: "10% 10% 3% 10%",
            }}
          >
            Analytics reports are the core strengths to perform real-time
            projects with assured high-end quality. We design and develop
            AI-generated architectural designs which produce the most optimized
            results in the desired budget limits
          </Typography>
        </Paper>
      </Box>
      <Technologies />
    </Box>
  );
};

export default AdvancedAI;
